<template lang="pug">
  .post-heading(v-if="heading || subHeading")
    h2.title(v-if="heading") {{ heading }}
    h3.subtitle(v-if="subHeading") {{ subHeading }}
</template>

<script>
export default {
    name: 'Heading',
    props: {
        heading: {
            type: String
        },
        subHeading: {
            type: String
        }
    }
};
</script>

<style lang="sass" scoped>
@import "~@/assets/sass/variables"

.post-heading
  @apply mb-6
  .title
    @apply text-2xl font-bold leading-none
    color: $color-primary
  .subtitle
    @apply text-lg text-black font-bold
</style>
